require('./utils/cordova-spinner-raf');
const AuthManagementDebug = require('services/auth-management/debug');
const { nonce } = require('./wiring/init-csp-nonce');
const InitViewportHeight = require('./utils/init-viewport-height');
const React = require('react');
const ReactDOM = require('react-dom/client');
const { StyleSheetManager } = require('styled-components');
const InitializePersistence = require('./wiring/initialize-persistence');

InitializePersistence();

const CreateStore = require('./wiring/create-store');
const History = require('./wiring/history');
const AppContainer = require('./containers/App');
const Initializers = require('./initializers');
const { theme: Theme } = require('styles/theme');

// Install the existing global error listeners before store creation and render.
AuthManagementDebug.installRecentErrorCapture();

// Create redux store and sync history with connected-react-router
const initialState = window.__INITIAL_STATE__;
const store = CreateStore({
    initialState,
    history: History
});

Initializers.run(store);

// Render Setup
const render = () => {

    const root = ReactDOM.createRoot(document.getElementById('root'));

    InitViewportHeight();

    if (nonce) {
        root.render(
            <StyleSheetManager nonce={nonce}>
                <AppContainer
                    store={store}
                    history={History}
                    routes={require('./routes')(store)}
                    theme={Theme}
                />
            </StyleSheetManager>
        );
    }
    else {
        root.render(
            <AppContainer
                store={store}
                history={History}
                routes={require('./routes')(store)}
                theme={Theme}
            />
        );
    }
};

// Enable HMR and catch runtime errors in RedBox
// This code is excluded from production bundle

if (__DEV__ && module.hot) {
    module.hot.accept(['./routes/index'], () => render());
}

// Go!
render();
